export default __webpack_public_path__ + "static/media/apple-first-gen.003f9847.jpg";